function galleryCarouselDetail() {
  //fancybox gallery for both mobile&desktop
  const extraImagesExample = [
    {
      filterName: '', //texts separated with |
      filterNameExclude: '', //texts separated with |
      filterBrand: '',
      filterSKU: '',
      imagePosition: 2,
      imageUrl: 'wilsondo_loop_uchytky.jpeg',
      imageThumbUrl: ''
    }
  ];
  
  function productGallery() {
    if(!$('body.type-product.type-detail').length) {
      return;
    }
    if(typeof Fancybox !== 'function' || typeof Carousel !== 'function') {
      return;
    }
    var galleryImages = $('.p-image-wrapper .p-thumbnails-wrapper .p-thumbnails-inner .p-thumbnail');
    
    $('<div>', {
      id: 'wm-gallery',
      class: 'wm-gallery-box carousel w-10/12 max-w-5xl mx-auto',
    }).appendTo($('.p-image-wrapper'));
    $('<div>', {
      id: 'wm-gallery-thumbs',
      class: 'wm-gallery-thumbs-box carousel max-w-xl mx-auto',
    }).appendTo($('.p-image-wrapper'));

    //products with single image
    if(galleryImages.length == 0) {
      var mainImage = $('.p-image-wrapper .p-image .p-main-image');
      if(mainImage) {
        galleryImages.push(mainImage);
      }
    }
    galleryImages.each(function( index ) {
      var imgSrc = $(this).attr('href');
      var imgOptions = {
        class: 'wm-gallery-img',
        'data-lazy-src': imgSrc,
        alt: $(this).children().attr('alt')
      }
      if(index == 0) {
        imgOptions.src = imgSrc;
      }
      $('<img />', imgOptions).appendTo($('body').find('#wm-gallery')).wrap('<div class="carousel__slide" data-src="'+imgSrc+'" data-fancybox="wgallery"></div>');
      var imgThumbOptions = {
        class: 'wm-gallery-img',
        src: $(this).children().attr('data-src') ? $(this).children().attr('data-src') : $(this).children().attr('src'),
        alt: $(this).children().attr('alt')
      }
      $('<img />', imgThumbOptions).appendTo($('body').find('#wm-gallery-thumbs')).wrap("<div class='carousel__slide'></div>");
    });
  
    //additional images from description
    var additionalImages = $('#description .basic-description img').not('.custom-description-with-img-wrap img');
    additionalImages.each(function( index ) {
      var imgSrc = $(this).attr('src');
      var imgOptions = {
        class: 'wm-gallery-img',
        'data-lazy-src': $(this).attr('src'),
        alt: $(this).attr('alt')
      }
      $('<img />', imgOptions).appendTo($('body').find('#wm-gallery')).wrap('<div class="carousel__slide" data-src="'+imgSrc+'" data-fancybox="wgallery"></div>');
  
      var imgThumbOptions = {
        class: 'wm-gallery-img',
        src: $(this).attr('src'),
        alt: $(this).attr('alt')
      }
      $('<img />', imgThumbOptions).appendTo($('body').find('#wm-gallery-thumbs')).wrap("<div class='carousel__slide'></div>");
    });
  
    //load youtube videos
    var videos = $('.p-detail-tabs-wrapper #description iframe[src*="youtube.com"]');

    var matchFound = false;
    var productTitle = $('.p-detail-inner-header h1').text().toLowerCase();

    if (productTitle.includes('aluria') || productTitle.includes('serenio')) {
      matchFound = true;
    }

    videos.each(function () {
      var videoId = youtube_parser($(this).attr('src'));
      if (!videoId) return;

      var videoSrc = 'https://www.youtube.com/watch?v=' + videoId;
      var $videoSlide = $('<div class="carousel__slide wm-gallery-video-box" data-fancybox="wgallery" href="' + videoSrc + '"></div>');
      var $video = $(this).clone();
      $videoSlide.append($video);

      var $thumbSlide = $('<div class="carousel__slide"><div class="wm-gallery-video"></div></div>');

      var $galleryTrack = $('#wm-gallery');
      var $thumbsTrack = $('#wm-gallery-thumbs');

      if (matchFound) {
        // na 4. pozíciu
        $galleryTrack.find('.carousel__slide').eq(2).after($videoSlide);
        $thumbsTrack.find('.carousel__slide').eq(2).after($thumbSlide);
      } else {
        // na koniec
        $galleryTrack.append($videoSlide);
        $thumbsTrack.append($thumbSlide);
      }
    });

  
    if(typeof extraImages !== 'undefined') {
      $.each( extraImages, function( index, value ){
        var filterNameResult = true;
          if(extraImages[index].filterName) {
            var filterName = extraImages[index].filterName.toString();
            if(filterName.length) {
              filterNameResult = false;
              var filterArray = filterName.split('|');
              $.each( filterArray, function( index, value ){
                if($('.p-detail-inner-header h1:contains("'+filterArray[index]+'")').length) {
                  filterNameResult = true;
                  return false;
                }
              });
            }
          }
          var filterNameExcludeResult = true;
          
          if(extraImages[index].filterNameExclude) {
            var filterNameExclude = extraImages[index].filterNameExclude.toString();
            if(filterNameExclude.length) {
              var filterArray = filterNameExclude.split('|');
              $.each( filterArray, function( index, value ){
                if($('.p-detail-inner-header h1:contains("'+filterArray[index]+'")').length) {
                  filterNameExcludeResult = false;
                  return false;
                }
              });
            }
          }

          var filterBrandResult = true;
          if(extraImages[index].filterBrand) {
            var filterBrand = extraImages[index].filterBrand.toString();
            if(filterBrand.length) {
              filterBrandResult = false;
              var filterArray = filterBrand.split('|');
              $.each( filterArray, function( index, value ){
                if($('a[data-testid="productCardBrandName"]:contains("'+filterArray[index]+'")').length) {
                  filterBrandResult = true;
                  return false;
                }
              });
            }
          }
  
          if(!filterNameResult || !filterBrandResult || !filterNameExcludeResult){
            return;
          }
  
          var position = extraImages[index].imagePosition ? extraImages[index].imagePosition : false;
          
          //higher position than number of images
          if(position && position > $('body').find('#wm-gallery .carousel__slide').length) {
            position = false;
          }
  
          var imgSrc = extraImages[index].imageUrl;

          var imgOptions = {
            class: 'wm-gallery-img',
            'data-lazy-src': extraImages[index].imageUrl
          }
          var imgThumbOptions = {
            class: 'wm-gallery-img',
            src: extraImages[index].imageThumbUrl ? extraImages[index].imageThumbUrl : extraImages[index].imageUrl
          }
  
        if(!position) {
          $('<img />', imgOptions).appendTo($('body').find('#wm-gallery')).wrap('<div class="carousel__slide" data-src="'+imgSrc+'" data-fancybox="wgallery"></div>');
          $('<img />', imgThumbOptions).appendTo($('body').find('#wm-gallery-thumbs')).wrap("<div class='carousel__slide'></div>");
        } else {
          position = position - 1;
          $('<img />', imgOptions).insertBefore($('body').find('#wm-gallery .carousel__slide:eq('+position+')')).wrap('<div class="carousel__slide" data-src="'+imgSrc+'" data-fancybox="wgallery"></div>');
          $('<img />', imgThumbOptions).insertBefore($('body').find('#wm-gallery-thumbs .carousel__slide:eq('+position+')')).wrap("<div class='carousel__slide'></div>");
        }
      });
    }
  
    $('.product-top .p-image-wrapper').addClass('w-gallery-loaded');
    // Initialise Carousel
    const wCarousel = new Carousel(document.querySelector("#wm-gallery"), {
      Dots: true,
      Navigation: false,
      Autoplay: false,
    });
  
    // Thumbnails
    const wThumbCarousel = new Carousel(document.querySelector("#wm-gallery-thumbs"), {
      Sync: {
        target: wCarousel,
        friction: 0,
      },
        Dots: false,
        Navigation: false,
        center: true,
        slidesPerPage: 1,
        infinite: false,
        Autoplay: false,
    });
  
    // Customize Fancybox
    Fancybox.bind('[data-fancybox="wgallery"]', {
      groupAll : true,
      Hash : false,
      Thumbs: {
        autoStart: false,
      },
      Toolbar: {
        display: [
          { id: "prev", position: "center" },
          { id: "counter", position: "center" },
          { id: "next", position: "center" },
          "zoom",
          //"slideshow",
          //"fullscreen",
          //"download",
          //"thumbs",
          "close",
        ],
      },
      Carousel: {
        on: {
          change: (that) => {
            wCarousel.slideTo(wCarousel.findPageForSlide(that.page), {
              friction: 0,
            });
          },
        },
      }
    });
  
    shoptet.scripts.setCustomCallback('shoptet.products.replaceImage', function(args) {
      if(args && args[0]) {
        let newImageUrl = args[0];
        let slideIndex = $('#wm-gallery .carousel__slide[data-src="'+newImageUrl+'"]').index();
        if(slideIndex >= 0) {
          wCarousel.slideTo(slideIndex, {
            friction: 0,
          });
        }
      }
    });
  }
  
  productGallery();
  
  function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&(match[7].length==11||match[7].length==10))? match[7] : false;
  }
}